//____ ANCHOR FOOTER NL POP-UP ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_footer() {
    $(document).on('click', '[data-nl-logo]', function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        $('.part_nl_logo_popup').fadeToggle('slow');
    });
}